var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_c('gantt-elastic',{attrs:{"tasks":_vm.tasks,"options":_vm.options}},[(0)?_c('gantt-header',{attrs:{"slot":"header"},slot:"header"}):_vm._e()],1):_vm._e(),(_vm.loading)?_c('div',{staticClass:"loading-block"},[_c('div',{staticClass:"loader"})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }